import { Link } from 'react-router-dom';
import { useI18n } from '@v2/providers/I18nProvider';
import type { CommissionGoalBucketRow } from '@v2/pages/commissioning/types';
import { fmtBrl } from './homeFormat';

type Props = {
    incomplete: CommissionGoalBucketRow | null;
    avgRate?: number | null;
};

export default function SellerBucketNudge({ incomplete, avgRate }: Props) {
    const { t } = useI18n();

    if (!incomplete || incomplete.pct >= 1) {
        return (
            <p className="text-center text-[11px] text-gray-400">
                {t('v2.my_commission.disclaimer')}
            </p>
        );
    }

    const missing = Math.max(0, incomplete.target - incomplete.achieved);
    const est = avgRate && avgRate > 0 ? missing * avgRate : null;

    return (
        <div className="space-y-3">
            <div className="flex flex-col gap-3 rounded-2xl bg-orange-600 px-5 py-4 text-white sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <p className="font-bold">
                        {t('v2.my_commission.nudge_title', { bucket: incomplete.label })}
                    </p>
                    <p className="text-sm text-orange-100">
                        {est != null
                            ? t('v2.my_commission.nudge_hint_with_est', {
                                missing: fmtBrl(missing),
                                commission: fmtBrl(est),
                            })
                            : t('v2.my_commission.nudge_hint', { missing: fmtBrl(missing) })}
                    </p>
                </div>
                <Link
                    to="/ploomes-deals"
                    className="inline-flex shrink-0 items-center justify-center rounded-xl bg-white px-4 py-2 text-sm font-semibold text-orange-700 hover:bg-orange-50"
                >
                    {t('v2.my_commission.nudge_cta')}
                </Link>
            </div>
            <p className="text-center text-[11px] text-gray-400">
                {t('v2.my_commission.disclaimer')}
            </p>
        </div>
    );
}
